import { useEffect, useRef } from "react";
import { onPreferenceChosen } from "../../app/preference-events";
import { usePreferencesState, useUpdatePreferences } from "./api";
import { applyPreferences, localPreferences } from "./apply";

/** Mounted in the shell: saved preferences win over this browser's caches; choices get saved. */
export function PreferencesSync() {
  const { data } = usePreferencesState();
  const { mutate } = useUpdatePreferences();
  const carriedOver = useRef(false);

  useEffect(() => onPreferenceChosen((patch) => mutate(patch)), [mutate]);

  useEffect(() => {
    if (!data) return;
    if (data.saved) {
      applyPreferences(data.value);
    } else if (!carriedOver.current) {
      // First visit since preferences are saved: this browser's choices become the saved ones.
      carriedOver.current = true;
      mutate(localPreferences());
    }
  }, [data, mutate]);

  return null;
}
